
const Login = () => import('./login.vue')
export default {
  path: '/login', 
  name: 'login',
  component: Login,
  children: [
  ]
}
